import { render } from "./Sait-ERP.vue?vue&type=template&id=2503309d&scoped=true"
import script from "./Sait-ERP.vue?vue&type=script&lang=js"
export * from "./Sait-ERP.vue?vue&type=script&lang=js"

import "./Sait-ERP.vue?vue&type=style&index=0&id=2503309d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2503309d"

export default script